// File Metadata:
// Filename: NewDepartureFormHU.js
// Version: 1.00
// Created: 2025-03-22 00:11:41
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React, { Component } from 'react'
import Scanner from '../../../components/Scanner'
import { Button, TextField, Modal, Card, CardHeader, CardContent, FormControl, ButtonGroup, Alert, List, ListItem, ListItemText, ListItemSecondaryAction, Typography, LinearProgress } from '@mui/material'
import { Box } from '@mui/system'


class NewDepartureFormHU extends Component {
    state = {
        scannedHUs: [],
        progress: 0,
        open: false,
        errMsg: ''
    }

    componentDidMount() {
        // Load saved progress from localStorage
        const savedState = localStorage.getItem(`departureProgress_${this.props.values.departureTour}`)
        if (savedState) {
            this.setState(JSON.parse(savedState))
        }
    }

    handleToggleScanner = () => {
        this.setState({ open: !this.state.open })
        if (this.state.errMsg) this.setState({ errMsg: '' })
    }

    handleDetected = result => {
        this.setState({ open: false }, () => {
            // Verify HU is in required list
            if (!this.props.values.pendingHUs.some(hu => hu.sscc === result)) {
                this.setState({ errMsg: 'This HU is not in the departure list!' })
                return
            }
            // Check for duplicates
            if (this.state.scannedHUs.includes(result)) {
                this.setState({ errMsg: 'This HU was already scanned!' })
                return
            }

            const newScannedHUs = [...this.state.scannedHUs, result]
            const progress = (newScannedHUs.length / this.props.values.pendingHUs.length) * 100

            this.setState({
                scannedHUs: newScannedHUs,
                progress,
                errMsg: ''
            }, () => {
                // Save progress to localStorage with tour number
                localStorage.setItem(
                    `departureProgress_${this.props.values.departureTour}`, 
                    JSON.stringify(this.state)
                )
            })
        })
    }

    next = e => {
        e.preventDefault()
        if (this.state.scannedHUs.length === this.props.values.pendingHUs.length) {
            this.props.handleValue('scannedHUs', this.state.scannedHUs)
            // Clear saved progress when moving forward
            localStorage.removeItem(`departureProgress_${this.props.values.departureTour}`)
            this.props.nextStep()
        } else {
            this.setState({ 
                errMsg: `Missing HUs! Scanned ${this.state.scannedHUs.length} of ${this.props.values.pendingHUs.length}` 
            })
        }
    }

    render() {
        const { pendingHUs } = this.props.values
        
        return (
            <>
                <Card sx={{ width: 345, minWidth: 200, boxShadow: 2, margin: 2 }}>
                    <CardHeader title='Scan Departing HUs' />
                    <CardContent>
                        {this.state.errMsg && <Alert severity='error'>{this.state.errMsg}</Alert>}
                        <Typography variant="body2" gutterBottom>
                            Progress: {this.state.scannedHUs.length} of {pendingHUs.length} HUs
                        </Typography>
                        <LinearProgress 
                            variant="determinate" 
                            value={this.state.progress} 
                            sx={{ mb: 2 }}
                        />
                        <List dense>
                            {pendingHUs.map((hu, index) => (
                                <ListItem key={index}>
                                    <ListItemText 
                                        primary={hu.sscc}
                                        secondary={this.state.scannedHUs.includes(hu.sscc) ? 'Scanned' : 'Pending'}
                                    />
                                    <ListItemSecondaryAction>
                                        {this.state.scannedHUs.includes(hu.sscc) && '✓'}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                        <ButtonGroup fullWidth variant='contained' sx={{ mt: 2 }}>
                            <Button onClick={this.handleToggleScanner}>Scan</Button>
                            <Button onClick={this.next}>Next</Button>
                        </ButtonGroup>
                    </CardContent>
                </Card>
                <Modal open={this.state.open} onClose={this.handleToggleScanner}>
                    <Box sx={style}>
                        <Scanner onDetected={this.handleDetected} />
                    </Box>
                </Modal>
            </>
        )
    }
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    bgcolor: 'background.paper',
    border: '2px dashed #555',
    boxShadow: 6,
    p: 4
}

export default NewDepartureFormHU
